<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-loader" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<section class="content">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-11 w3-center">
        <img src="../assets/images/bsflogo.png" class="img-circle" alt="BRR" style="max-height: 80px;;margin-top: 5px;">
      </div>
      <div class="w3-center w3-xlarge" style="font-weight: bolder;">
        Buriram Sugar Public Co., Ltd.
      </div>
      <div class="w3-center w3-large" style="font-weight: bolder;">
        ปริมาณอ้อยเข้าหีบรายวัน
      </div>
      <div class="w3-center" style="font-weight: bold;">
        ประจำปีการผลิตปี {{ yearLabelTh! }}
      </div>
    </div>
  </div>


  <!-- <div class="row justify-content-md-center bg-primary disabled color-palette">
    <div class="col-md-10 text-center">
      <h1 style="font-size: 18; color: #fff;">
        <img src="../assets/images/bsflogo.png" class="img-circle" alt="User Image"
          style="width: 5%; height: 95%; background-color: white;">
        ปริมาณอ้อยเข้าหีบรายวัน ประจำปีการผลิต 2567/2568
      </h1>

    </div>
    <div class="col-md-auto" *ngIf="loader">
      <mat-spinner color="warn"></mat-spinner>
    </div>
  </div> -->


  <div class="row justify-content-center">
    <div class="col-lg-10">
      <div class="table-responsive p-0">
        <table class="table table-striped table-head-fixed text-nowrap table-bordered border-primary" #table>
          <thead class="text-center">
            <tr>
              <th class="sticky-col bg-light color-palette">
                <button class="btn btn-outline-success btn-sm" (click)="ExportExcel();" *ngIf="dataperday.length>0">
                  <i class="far fa-file-excel"></i>
                </button>
              </th>
              <th class="sticky-col bg-secondary color-palette"><i class="fas fa-calendar-alt"></i></th>
              <th colspan="4" class="bg-success  color-palette">อ้อยสด</th>
              <th colspan="4" class="bg-danger  color-palette">อ้อยไฟ</th>
              <th colspan="3" class="bg-primary  color-palette">รวม</th>
            </tr>
            <tr>
              <th class="sticky-col bg-primary disabled color-palette">#</th>
              <th class="sticky-col bg-secondary disabled color-palette">วันที่</th>
              <th class="bg-success disabled color-palette">จำนวนคัน</th>
              <th class="bg-success disabled color-palette">ปริมาณอ้อย</th>
              <th class="bg-success disabled color-palette">%</th>
              <th class="bg-success disabled color-palette">ccs เฉลี่ย</th>
              <th class="bg-danger disabled color-palette">จำนวนคัน</th>
              <th class="bg-danger disabled color-palette">ปริมาณอ้อย</th>
              <th class="bg-danger disabled color-palette">%</th>
              <th class="bg-danger disabled color-palette">ccs เฉลี่ย</th>
              <th class="bg-primary disabled color-palette">จำนวนคัน</th>
              <th class="bg-primary disabled color-palette">ปริมาณอ้อย</th>
              <th class="bg-primary disabled color-palette">ccs เฉลี่ย</th>
            </tr>
            <tr *ngFor="let s of sumdata" class="under">
              <td></td>
              <td class="sticky-col color-palette">รวม</td>
              <td class="color-palette">{{s.sum_cnt_fresh | number}}</td>
              <td class="color-palette">{{s.sum_wgt_fresh | number:'1.2-2'}}</td>
              <td class="color-palette">{{calPercen(s.sum_wgt_all,s.sum_wgt_fresh) | number:'1.2-2'}}</td>
              <td class="color-palette">{{s.sum_avg_fresh | number:'1.2-2'}}</td>
              <td class="color-palette">{{s.sum_cnt_fire | number}}</td>
              <td class="color-palette">{{s.sum_wgt_fire | number:'1.2-2'}}</td>
              <td class="color-palette">{{calPercen(s.sum_wgt_all,s.sum_wgt_fire) | number:'1.2-2'}}</td>
              <td class="color-palette">{{s.sum_avg_fire | number:'1.2-2'}}</td>
              <td class="color-palette">{{s.sum_cnt_all | number}}</td>
              <td class="color-palette">{{s.sum_wgt_all | number:'1.2-2'}}</td>
              <td class="color-palette">{{s.sum_avg_all | number:'1.2-2'}}</td>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr *ngFor="let item of dataperday;index as i">
              <td style="background-color: #d6d6d6;">{{i+1}}</td>
              <td class="sticky-col bg-secondary disabled p-2 bg-opacity-80">{{FormatThai(item.REPORTDATE)}}</td>
              <td style="color: green;">{{item.cnt_fresh | number}}</td>
              <td style="color: green;">{{item.wgt_fresh | number:'1.2-2'}}</td>
              <td style="color: green;">{{calPercen(item.wgt_all,item.wgt_fresh) | number:'1.2-2'}}</td>
              <td style="color: green;">{{item.avg_fresh | number:'1.2-2'}}</td>
              <td style="color: red;">{{item.cnt_fire | number}}</td>
              <td style="color: red;">{{item.wgt_fire | number:'1.2-2'}}</td>
              <td style="color: red;">{{calPercen(item.wgt_all,item.wgt_fire) | number:'1.2-2'}}</td>
              <td style="color: red;">{{item.avg_fire | number:'1.2-2'}}</td>
              <td style="color: blue;">{{item.cnt_all | number}}</td>
              <td style="color: blue;">{{item.wgt_all | number:'1.2-2'}}</td>
              <td style="color: blue;">{{item.avg_all | number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>